import React from 'react';
import { List, Typography, Empty, Spin, Tag, Space } from 'antd';
import { FileExcelOutlined, FilePdfOutlined } from '@ant-design/icons';
import "./NotificationComponent.css";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

const { Text } = Typography;

const getStatusColor = (status) => {
  switch (status) {
    case 'PENDING':
      return '#faad14';
    case 'COMPLETED':
      return '#abf5d1';
    case 'FAILED':
      return '#ff4d4f';
       case 'SUCCESS':
      return '#abf5d1';
    default:
      return '#e8e8e8';
  }
};

const NotificationComponent = ({ notifications = [], isLoading }) => {
  if (isLoading) {
    return (
      <div className="notification-container notification-loading">
        <Spin />
      </div>
    );
  }

  if (!notifications.length) {
    return (
      <div className="notification-container">
        <Empty
          description="No notifications"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );
  }

  return (
    <div className="notification-container">
      <List
        itemLayout="vertical"
        dataSource={notifications}
        renderItem={(item) => (
          <List.Item className={`notification-item ${!item.is_read ? 'unread' : ''}`}>
            <List.Item.Meta
              title={
                <div className="notification-header">
                  <Text strong style={{ marginRight: '8px' }}>{item.title}</Text>
                  <Tag style={{color:"#006644"}} color={getStatusColor(item.status)}>{item.status}</Tag>
                </div>
              }
              description={
                <div className="notification-content">
                  <Text type="secondary">{item.message}</Text>
                  {item.error && (
                    <Text type="danger" className="notification-error">
                      {item.error}
                    </Text>
                  )}
                  {(item.excel_url || item.pdf_url) && (
                    <Space className="notification-links">
                      {item.excel_url && (
                        <a href={item.excel_url} target="_blank" rel="noopener noreferrer">
                          <FileExcelOutlined style={{ fontSize: '16px', color: '#217346' }} /> Excel
                        </a>
                      )}
                      {item.pdf_url && (
                        <a href={item.pdf_url} target="_blank" rel="noopener noreferrer">
                          <FilePdfOutlined style={{ fontSize: '16px', color: '#FF4D4F' }} /> PDF
                        </a>
                      )}
                    </Space>
                  )}
                </div>
              }
            />
            <Text type="secondary" className="notification-time">
              {dayjs(item.created_at).fromNow()}
            </Text>
          </List.Item>
        )}
      />
    </div>
  );
};

export default NotificationComponent;